import * as React from "react"
import { Tooltip } from "antd"
import PropTypes from "prop-types"
import "./DateBadge.scss"

const DateBadge = ({
  badgeType,
  date, // optional
}) => {
  const [className, setClassName] = React.useState("")
  const [badgeLetter, setBadgeLetter] = React.useState("")
  const [tooltip, setTooltip] = React.useState("")

  React.useEffect(() => {
    switch (badgeType) {
      case "Anticipated":
        setClassName("anticipated")
        setBadgeLetter("F")
        setTooltip("Forecast")
        break
      case "Forecast":
        setClassName("forecast")
        setBadgeLetter("F")
        setTooltip("Forecast")
        break
      case "Projected":
        setClassName("projected")
        setBadgeLetter("P")
        setTooltip("Projected")
        break
      case "Baseline":
        setClassName("baseline")
        setBadgeLetter("B")
        setTooltip("Baseline")
        break
      case "Actual":
        setClassName("actual")
        setBadgeLetter("A")
        setTooltip("Actual")
        break
      default:
    }
  }, [badgeType])

  return (
    <div className={`date-badge ${className ? " " + className : ""}`}>
      <Tooltip title={tooltip}>
        <div className="date-badge-letter">{badgeLetter}</div>
      </Tooltip>
      {date && <span className="date-badge-date">{date}</span>}
    </div>
  )
}

DateBadge.propTypes = {
  date: PropTypes.string,
  badgeType: PropTypes.oneOf(["Anticipated", "Forecast", "Projected", "Baseline", "Actual"]).isRequired,
}

export default DateBadge
